import { createFileRoute } from "@tanstack/react-router";
import TemplateSheetsPage from "@/pages/TemplateSheetsPage";

export const Route = createFileRoute("/learn/sheets/")({
  head: () => ({
    meta: [
        {
            "title": "Fiches de révision gratuites à télécharger | System Atlas"
        },
        {
            "name": "description",
            "content": "Fiches de révision prêtes à l'emploi en médecine, droit, ingénierie, sciences et plus. Modèles structurés, gratuits, à réviser immédiatement."
        },
        {
            "property": "og:title",
            "content": "Fiches de révision gratuites à télécharger | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Fiches de révision prêtes à l'emploi en médecine, droit, ingénierie, sciences et plus. Modèles structurés, gratuits, à réviser immédiatement."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/sheets"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Fiches de révision gratuites à télécharger | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Fiches de révision prêtes à l'emploi en médecine, droit, ingénierie, sciences et plus. Modèles structurés, gratuits, à réviser immédiatement."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    scripts: [{ type: "application/ld+json", children: JSON.stringify({"@context": "https://schema.org", "@type": "CollectionPage", "name": "Revision Sheet Library", "description": "Browse free structured revision sheet templates.", "url": "https://systematlas.fr/learn/sheets", "inLanguage": "en", "isPartOf": {"@type": "WebSite", "name": "System Atlas", "url": "https://systematlas.fr"}}) }],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/sheets"
        }
    ],
  }),
  component: TemplateSheetsPage,
});
